import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae91533a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "ザギエの風車", -1))
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" pが4で割って1余る素数のとき、x"),
  /*#__PURE__*/_createElementVNode("sup", null, "2"),
  /*#__PURE__*/_createTextVNode("+(2y)"),
  /*#__PURE__*/_createElementVNode("sup", null, "2"),
  /*#__PURE__*/_createTextVNode(" = p をみたす正の整数 x,yが存在することを以下のように証明する。")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" Step1: x"),
    /*#__PURE__*/_createElementVNode("sup", null, "2"),
    /*#__PURE__*/_createTextVNode(" + 4yz = p をみたす正の整数 (x,y,z) の組の個数は奇数であることを、「風車」の絵を使って示す。")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, " Step2: (x,y,z) と (x,z,y) を対にしていくことで、 y = z をみたす組が存在することを確かめる。")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " 入力 ", -1))
const _hoisted_6 = { class: "center" }
const _hoisted_7 = { class: "center error" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " 図示 ", -1))
const _hoisted_9 = { class: "buttonContainer" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "50",
  height: "50"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    style: {"stroke":"black","stroke-width":"2"},
    x1: "0",
    y1: "25",
    x2: "50",
    y2: "25"
  })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["viewBox"]
const _hoisted_15 = ["x1", "x2", "y2"]
const _hoisted_16 = ["x2", "y1", "y2"]
const _hoisted_17 = ["x1", "y1", "x2", "y2"]

import { ref, computed, nextTick } from 'vue';
import MillRect from '@/components/MillRect.vue';

interface lineI {
  x1: number;
  y1: number;
  x2:number;
  y2: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ZagierMill',
  setup(__props) {

class tripleC{
  id: number;
  x: number;
  y: number;
  z: number;
  sty: string;
  s0r: number;
  s1c: number;
  s1r: number;
  s2c: number;
  s2r: number;
  s1to: tripleC | null;
  s2to: tripleC | null;
  constructor(id:number, x:number, y:number, z:number){
    this.id = id;
    this.x = x;
    this.y = y;
    this.z = z;
    this.s0r = id;
    this.s1c = -1;
    this.s1r = -1;
    this.s2c = -1;
    this.s2r = -1;
    this.sty = '';
    this.s1to = null;
    this.s2to = null;
  }
  get s1(){
    return (this.y > this.x+this.z) ? 'A' : (this.y > this.x) ? 'B1' : (this.y == this.x) ? 'B2' : (2*this.y > this.x) ? 'B3' : 'C';
  }
  get color1(){
    return (this.s1 == 'A') ? 'blue' : (this.s1 == 'C') ? 'green' : 'orange';
  }
  get color2(){
    return (this.y == this.z) ? 'red' : 'black';
  }
  get nx(){
    return (this.s1 == 'A') ? this.x + 2*this.z : (this.s1 == 'C') ? this.x - 2*this.y : 2*this.y - this.x;
  }
  get ny(){
    return (this.s1 == 'A') ? this.z : (this.s1 == 'C') ? this.x - this.y + this.z : this.y;
  }
  get nz(){
    return (this.s1 == 'A') ? -this.x + this.y - this.z : (this.s1 == 'C') ? this.y : this.x - this.y + this.z;
  }
}
const boxWidth = 150;
const boxHeight = 50;
const boxGap = 10;
const svgSize = 700;

const nullObj = new tripleC(-1,1,1,1)
const p = ref(17);
const showResult = ref(false);
const message = ref('');
const step = ref(0);
const triples = ref(new Array<tripleC>());
const bars = ref(new Array<string>());

function compare(a: tripleC, b:tripleC){
  if(a.s1 < b.s1){
    return -1;
  }else if(a.s1 > b.s1){
    return 1;
  }else{
    return a.s1r - b.s1r;
  }
}

const calc = function(){
  showResult.value = false;
  showFig.value = false;
  fig.value = new tripleC(-1,1,1,1);
  message.value = '';

  const myp = Number(p.value);
  if( ! Number.isInteger(myp) || myp <= 1 ){
    message.value = '2以上の整数を入力して下さい。';
    return;
  }
  for(let i=2; i*i<=myp; i++){
    if(myp % i == 0){
      message.value = '素数ではありません。';
      return;
    }
  }
  if(myp % 4 != 1){
    message.value = '4で割った余りが1ではありません。';
    return;
  }

  // make triples 
  triples.value.splice(0);
  let id = 0;
  for(let x=1; x*x < myp; x++){
    for(let y=1; x*x+4*y <= myp; y++){
      if( (myp - x*x) % (4*y) == 0 ){
	const z = (myp - x*x) / (4*y);
	triples.value.push( new tripleC(id,x,y,z) );
	id += 1;
      }
    }
  }

  // make step1 pairing
  let row = 0;
  for(const obj of triples.value.filter( e => e.s1 == 'A') ){
    obj.s1r = row;
    obj.s1c = 0;
    let flag = true;
    for(const another of triples.value.filter( e => e.s1 == 'C') ){
      if(another.x == obj.nx && another.y == obj.ny && another.z == obj.nz){
	obj.s1to = another;
	another.s1to = obj;
	another.s1r = row;
	another.s1c = 2;
	flag = false;
	break;
      }      
    }
    if(flag){
      message.value = `Step1 : Could not find pair for (${obj.x},${obj.y},${obj.z}) of type ${obj.s1}. `;
    }
    row += 1;
  }
  for(const obj of triples.value.filter( e => e.s1 == 'B1') ){
    obj.s1r = row;
    obj.s1c = 0;
    let flag = true;
    for(const another of triples.value.filter( e => e.s1 == 'B3') ){
      if(another.x == obj.nx && another.y == obj.ny && another.z == obj.nz){
	obj.s1to = another;
	another.s1to = obj;
	another.s1r = row;
	another.s1c = 2;
	flag = false;
	break;
      }      
    }
    if(flag){
      message.value = `Step1 : Could not find pair for (${obj.x},${obj.y},${obj.z}) of type ${obj.s1}. `;
    }
    row += 1;
  }
  for(const obj of triples.value.filter( e => e.s1 == 'B2') ){
    obj.s1to = obj;
    obj.s1r = row;
    obj.s1c = 1;
    break;
  }
  for(const obj of triples.value ){
    if(obj.s1r < 0){
      message.value = `Step1 : Could not find pair for (${obj.x},${obj.y},${obj.z}) of type ${obj.s1}. `;
    }
  }

  // make step2 pairing
  triples.value.sort(compare);
  row = 0;
  for(const obj of triples.value){
    if(obj.s2r >= 0){
      continue;
    }
    if(obj.y == obj.z){
      obj.s2to = obj;
      obj.s2r = row;
      obj.s2c = 1;
      row += 1;
      continue;
    }
    obj.s2r = row;
    obj.s2c = 0;
    let flag = true;
    for(const another of triples.value ){
      if(another.s2r < 0 && another.y == obj.z && another.z == obj.y){
	obj.s2to = another;
	another.s2to = obj;
	another.s2r = row;
	another.s2c = 2;
	flag = false;
	break;
      }      
    }
    if(flag){
      message.value = `Step2 : Could not find pair for (${obj.x},${obj.y},${obj.z}). `;
    }
    row += 1;
  }

  const w = 2*boxWidth + 50 + 4*boxGap;
//   const h = triples.value.length * (boxHeight + boxGap) + boxGap;  
  containerSty.value = `width: ${w  + 50 + svgSize}px; height:${svgSize + 50}px`;
  tripleContainerSty.value = `width: ${w}px; height:${svgSize+50}px`;
  figSty.value = `left: ${w + 40}px; width: ${svgSize}px;`;
  
  nextTick( () => {
    showResult.value = true;
    toStep(0);
  });
}

let moving = false;
const containerSty = ref('');
const tripleContainerSty = ref('');
const toStep = function(s:number){
  if(moving || movingFig || (s > 0 && step.value == s)){
    return;
  }
  step.value = s;
  bars.value.splice(0);
  
  const left=[boxGap, boxWidth/2 + 25 + 2*boxGap, boxWidth + 50 + 3*boxGap];
  const barLeft = boxWidth + 2*boxGap;
  if(s == 0){
    for(const obj of triples.value){
      obj.sty=`color:black; border-color:black; left:${left[1]}px; top:${obj.s0r*(boxHeight + boxGap) + boxGap}px;`
    }
    showFig.value = false;
    fig.value = nullObj;
  }else if(s == 1){
    for(const obj of triples.value){
      obj.sty=`color:${obj.color1}; border-color:${obj.color1}; left:${left[obj.s1c]}px; top:${obj.s1r*(boxHeight + boxGap) + boxGap}px;`
    }
    moving = true;
    setTimeout( () => {
      for(const obj of triples.value){
	if(obj.s1c == 0){
	  bars.value.push(`left: ${barLeft}px; top:${obj.s1r*(boxHeight + boxGap) + boxGap}px;`);
	}
      }
      moving = false;
    }, 3000);    
  }else if(s == 2){
    for(const obj of triples.value){
      obj.sty=`color:${obj.color2}; border-color:${obj.color2}; left:${left[obj.s2c]}px; top:${obj.s2r*(boxHeight + boxGap) + boxGap}px;`
    }
    moving = true;
    setTimeout( () => {
      for(const obj of triples.value){
	if(obj.s2c == 0){
	  bars.value.push(`left: ${barLeft}px; top:${obj.s2r*(boxHeight + boxGap) + boxGap}px;`);
	}
      }
      moving = false;
    }, 3000);    
  }
}

let movingFig = false;
const showFig = ref(false);
const figSty = ref('');
const figEnd = ref(false);
const viewBox = computed( () => `-0.1 -0.1 ${size.value+0.2} ${size.value+0.2}` );
const fig = ref(nullObj);
const newfig = ref(nullObj);
const divLines = ref(new Array<lineI>());

const drawFig = function(obj: tripleC){
  showFig.value = true;
  figEnd.value = false;
  divLines.value.splice(0);
  fig.value = obj;
}

const size = computed( () => {
  const l1 = 2*fig.value.y - fig.value.x;
  const l2 = fig.value.x + 2*fig.value.z;
  const l3 = 2*fig.value.z - fig.value.x;
  const l4 = fig.value.x + 2*fig.value.y;  
  if(step.value <= 1){
    return Math.max(l1,l2)+2;
  }else{
    return Math.max(l1,l2,l3,l4)+2;
  }
})
const transS = computed( () => {
  const m = (size.value - fig.value.x) /2;
  return`translate(${m},${m}) rotate(0)`;
});
const trans1 = computed( () => {
  const m = (size.value - fig.value.x) /2;
  if(fig.value.s1 != 'B3'){
    return `translate(${m},${m}) rotate(-90)`;
  }else{
    return `translate(${m+fig.value.x-fig.value.y},${m}) rotate(-90)`;
  }
});
const trans2 = computed( () => {
  const m = (size.value - fig.value.x) /2;
  if(fig.value.s1 != 'B3'){
    return `translate(${m + fig.value.x},${m}) rotate(0)`;
  }else{
    return `translate(${m + fig.value.x},${m+fig.value.x-fig.value.y}) rotate(0)`;
  }
});
const trans3 = computed( () => {
  const m = (size.value - fig.value.x) /2;
  if(fig.value.s1 != 'B3'){
    return `translate(${m + fig.value.x},${m+fig.value.x}) rotate(90)`;
  }else{
    return `translate(${m + fig.value.y},${m+fig.value.x}) rotate(90)`;
  }
});
const trans4 = computed( () => {
  const m = (size.value - fig.value.x) /2;
  if(fig.value.s1 != 'B3'){
    return `translate(${m},${m+fig.value.x}) rotate(180)`;
  }else{
    return `translate(${m},${m+fig.value.y}) rotate(180)`;
  }
});

const choose = function(v: tripleC | null){
  if(v != null){
    fig.value = v;    
  }
}
// const startMove = function(){
//   if(moving || movingFig || figEnd.value || step.value == 0){
//     return;
//   }
//   movingFig = true;
//   const obj = fig.value;
//   const m = obj.y > obj.z ? obj.y : obj.z;
  
//   if(step.value == 1){
//     if(obj.s1 == 'A'){
//       divLines.value = [
// 	{x1: m+obj.x+obj.z, x2: m+obj.x+obj.z, y1: m-obj.z, y2: m-obj.z},
// 	{x1: m+obj.x+obj.z, x2: m+obj.x+obj.z, y1: m+obj.x+obj.z, y2: m+obj.x+obj.z},
// 	{x1: -obj.z, x2: -obj.z, y1: m+obj.x+obj.z, y2: m+obj.x+obj.z},
// 	{x1: -obj.z, x2: -obj.z, y1: m+obj.x+obj.z, y2: m+obj.x+obj.z}	
//       ];
//     }else if(obj.s1 == 'B1'){
      
//   }
// }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(" p = "),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((p).value = $event)),
          type: "text"
        }, null, 512), [
          [
            _vModelText,
            p.value,
            void 0,
            { number: true }
          ]
        ]),
        _createElementVNode("button", { onClick: calc }, " 決定 ")
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(message.value), 1),
      (showResult.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass(["button", {selected: step.value == 1}]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toStep(1)))
              }, " Step 1 ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["button", {selected: step.value == 2}]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toStep(2)))
              }, " Step 2 ", 2),
              _createElementVNode("div", {
                class: "button buttonG",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (toStep(0)))
              }, " Reset ")
            ]),
            _createElementVNode("div", {
              class: "container",
              style: _normalizeStyle(containerSty.value)
            }, [
              _createElementVNode("div", {
                class: "tripleContainer",
                style: _normalizeStyle(tripleContainerSty.value)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(triples.value, (obj) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: obj.id,
                    class: _normalizeClass(["triple", {drawn: obj == fig.value}]),
                    style: _normalizeStyle(obj.sty),
                    onClick: ($event: any) => (drawFig(obj))
                  }, " ( " + _toDisplayString(obj.x) + ", " + _toDisplayString(obj.y) + ", " + _toDisplayString(obj.z) + " ) ", 15, _hoisted_10))
                }), 128))
              ], 4),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bars.value, (sty, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'bar-' + index,
                  class: "bar",
                  style: _normalizeStyle(sty)
                }, _hoisted_12, 4))
              }), 128)),
              (showFig.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "fig",
                    style: _normalizeStyle(figSty.value)
                  }, [
                    (step.value > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Step " + _toDisplayString(step.value) + " : ", 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" ( " + _toDisplayString(fig.value.x) + ", " + _toDisplayString(fig.value.y) + ", " + _toDisplayString(fig.value.z) + " ) ", 1),
                    (step.value == 1)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          style: _normalizeStyle({color:fig.value.color1})
                        }, "[" + _toDisplayString(fig.value.s1) + "]", 5))
                      : _createCommentVNode("", true),
                    (step.value == 1)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: "link",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (choose(fig.value.s1to)))
                        }, [
                          _createTextVNode(" → ( " + _toDisplayString(fig.value.nx) + ", " + _toDisplayString(fig.value.ny) + ", " + _toDisplayString(fig.value.nz) + " ) ", 1),
                          _createElementVNode("span", {
                            style: _normalizeStyle({color:fig.value.s1to.color1})
                          }, "[" + _toDisplayString(fig.value.s1to.s1) + "]", 5)
                        ]))
                      : _createCommentVNode("", true),
                    (step.value == 2)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 3,
                          class: "link",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (choose(fig.value.s2to)))
                        }, " → ( " + _toDisplayString(fig.value.x) + ", " + _toDisplayString(fig.value.z) + ", " + _toDisplayString(fig.value.y) + " )", 1))
                      : _createCommentVNode("", true),
                    (_openBlock(), _createElementBlock("svg", {
                      class: "svg",
                      width: svgSize,
                      height: svgSize,
                      viewBox: _unref(viewBox)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(size)+1), (x) => {
                        return (_openBlock(), _createElementBlock("line", {
                          key: 'vert-' + x,
                          class: "mesh",
                          x1: x-1,
                          x2: x-1,
                          y1: "0",
                          y2: _unref(size)
                        }, null, 8, _hoisted_15))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(size)+1), (y) => {
                        return (_openBlock(), _createElementBlock("line", {
                          key: 'hori-' + y,
                          class: "mesh",
                          x1: "0",
                          x2: _unref(size),
                          y1: y-1,
                          y2: y-1
                        }, null, 8, _hoisted_16))
                      }), 128)),
                      (figEnd.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(MillRect, {
                              key: "nsq",
                              trans: _unref(transS),
                              w: newfig.value.x,
                              h: newfig.value.x,
                              sq: true
                            }, null, 8, ["trans", "w", "h"]),
                            _createVNode(MillRect, {
                              key: "nr1",
                              trans: _unref(trans1),
                              w: newfig.value.z,
                              h: newfig.value.y,
                              sq: false
                            }, null, 8, ["trans", "w", "h"]),
                            _createVNode(MillRect, {
                              key: "nr2",
                              trans: _unref(trans2),
                              w: newfig.value.z,
                              h: newfig.value.y,
                              sq: false
                            }, null, 8, ["trans", "w", "h"]),
                            _createVNode(MillRect, {
                              key: "nr3",
                              trans: _unref(trans3),
                              w: newfig.value.z,
                              h: newfig.value.y,
                              sq: false
                            }, null, 8, ["trans", "w", "h"]),
                            _createVNode(MillRect, {
                              key: "nr4",
                              trans: _unref(trans4),
                              w: newfig.value.z,
                              h: newfig.value.y,
                              sq: false
                            }, null, 8, ["trans", "w", "h"])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(MillRect, {
                        key: "sq",
                        trans: _unref(transS),
                        w: fig.value.x,
                        h: fig.value.x,
                        sq: true
                      }, null, 8, ["trans", "w", "h"]),
                      _createVNode(MillRect, {
                        key: "r1",
                        trans: _unref(trans1),
                        w: fig.value.z,
                        h: fig.value.y,
                        sq: false
                      }, null, 8, ["trans", "w", "h"]),
                      _createVNode(MillRect, {
                        key: "r2",
                        trans: _unref(trans2),
                        w: fig.value.z,
                        h: fig.value.y,
                        sq: false
                      }, null, 8, ["trans", "w", "h"]),
                      _createVNode(MillRect, {
                        key: "r3",
                        trans: _unref(trans3),
                        w: fig.value.z,
                        h: fig.value.y,
                        sq: false
                      }, null, 8, ["trans", "w", "h"]),
                      _createVNode(MillRect, {
                        key: "r4",
                        trans: _unref(trans4),
                        w: fig.value.z,
                        h: fig.value.y,
                        sq: false
                      }, null, 8, ["trans", "w", "h"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(divLines.value, (l, index) => {
                        return (_openBlock(), _createElementBlock("line", {
                          key: index,
                          class: "divLine",
                          x1: l.x1,
                          y1: l.y1,
                          x2: l.x2,
                          y2: l.y2
                        }, null, 8, _hoisted_17))
                      }), 128))
                    ], 8, _hoisted_14))
                  ], 4))
                : _createCommentVNode("", true)
            ], 4)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})